module.exports = __webpack_public_path__ + "static/subscription-background-88f5490cd1010005b4e91dcd541fa59a.jpg";